// Routes for the Insights pages (helpers/insights/insightPages.js has the list, the flag and the
// role gates).
//
// Each page is its own lazy chunk, so none of the Insights code loads for anyone who never opens
// one. The guard sends a user to the Command Center when the flag is off or their role doesn't
// open the page. That's the same front-end-only rule CGS's menu applies. The API scopes the
// data either way.

import { INSIGHT_PAGES, INSIGHTS_BASE, insightPath, isInsightsEnabled, canSeeInsightPage, visibleInsightPages } from '@/helpers/insights/insightPages.js'

// slug → page component. A page joins the app by being added here AND being in INSIGHT_PAGES.
export const INSIGHT_COMPONENTS = {
  'active-pipeline': () => import(/* webpackChunkName: "insights" */ '@/views/insights/ActivePipelineInsight.vue'),
  'applications': () => import(/* webpackChunkName: "insights-applications" */ '@/views/insights/ApplicationsInsight.vue'),
  'locks': () => import(/* webpackChunkName: "insights-locks" */ '@/views/insights/LocksInsight.vue'),
  'loan-risk': () => import(/* webpackChunkName: "insights-loan-risk" */ '@/views/insights/LoanRiskInsight.vue'),
  'origination': () => import(/* webpackChunkName: "insights-origination" */ '@/views/insights/OriginationInsight.vue'),
  'funding': () => import(/* webpackChunkName: "insights-funding" */ '@/views/insights/FundingInsight.vue'),
  'loan-officers': () => import(/* webpackChunkName: "insights-loan-officers" */ '@/views/insights/LoanOfficerInsight.vue'),
  'performance-scorecard': () => import(/* webpackChunkName: "insights-performance-scorecard" */ '@/views/insights/PerformanceScorecardInsight.vue'),
  'weekly-summary': () => import(/* webpackChunkName: "insights-weekly-summary" */ '@/views/insights/WeeklySummaryInsight.vue'),
  'revenue-active-locks': () => import(/* webpackChunkName: "insights-revenue-active-locks" */ '@/views/insights/RevenueActiveLocksInsight.vue'),
  'investor-shipping': () => import(/* webpackChunkName: "insights-investor-shipping" */ '@/views/insights/InvestorShippingInsight.vue'),
  'warehouse': () => import(/* webpackChunkName: "insights-warehouse" */ '@/views/insights/WarehouseInsight.vue'),
  'marketing': () => import(/* webpackChunkName: "insights-marketing" */ '@/views/insights/MarketingInsight.vue'),
  'dialpad': () => import(/* webpackChunkName: "insights-dialpad" */ '@/views/insights/DialpadInsight.vue'),
  'scenario-builder': () => import(/* webpackChunkName: "insights-scenario-builder" */ '@/views/insights/ScenarioBuilderInsight.vue'),
  'support': () => import(/* webpackChunkName: "insights-support" */ '@/views/insights/SupportMetricsInsight.vue'),
  'executive': () => import(/* webpackChunkName: "insights-executive" */ '@/views/insights/ExecutiveInsight.vue'),
  'baldwin': () => import(/* webpackChunkName: "insights-baldwin" */ '@/views/insights/BaldwinInsight.vue')
}

function guard(page) {
  return () => {
    if (!isInsightsEnabled() || !canSeeInsightPage(page)) return { path: '/' }
    return true
  }
}

export const insightRoutes = [
  {
    path: INSIGHTS_BASE,
    name: 'insightsHome',
    redirect: () => {
      const first = visibleInsightPages().find(p => INSIGHT_COMPONENTS[p.slug])
      return first ? insightPath(first.slug) : '/'
    }
  },
  ...INSIGHT_PAGES.filter(p => INSIGHT_COMPONENTS[p.slug]).map(p => ({
    path: insightPath(p.slug),
    name: `insights-${p.slug}`,
    component: INSIGHT_COMPONENTS[p.slug],
    meta: { insight: p.slug },
    beforeEnter: guard(p)
  }))
]
